// extracted by mini-css-extract-plugin
module.exports = {"title":"Title-module_title_21JAg","grid":"Title-module_grid_3aQxO"};